<template>
  <b-modal v-model="showCreateModal" title="Create Interview" hide-footer>
    <b-form @submit.prevent="submitForm">
      <b-form-group label="Candidate Name" label-for="candidateName">
        <b-form-input
          id="candidateName"
          v-model="interview.candidateName"
          placeholder="Enter candidate's name"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Position" label-for="position">
        <b-form-input
          id="position"
          v-model="interview.position"
          placeholder="Enter position"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Interview Date" label-for="interviewDate">
        <b-form-input
          id="interviewDate"
          type="date"
          v-model="interview.interviewDate"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Status" label-for="status">
        <b-form-select
          id="status"
          v-model="interview.status"
          :options="statusOptions"
          required
        ></b-form-select>
      </b-form-group>

      <b-form-group label="Notes" label-for="notes">
        <b-form-textarea
          id="notes"
          v-model="interview.notes"
          placeholder="Enter any notes"
          rows="3"
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" variant="success">Create Interview</b-button>
      <b-button variant="secondary" @click="closeModal">Cancel</b-button>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  props: {
    showCreateModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      interview: {
        candidateName: '',
        position: '',
        interviewDate: '',
        status: 'Scheduled',
        notes: '',
      },
      statusOptions: [
        { value: 'Scheduled', text: 'Scheduled' },
        { value: 'Completed', text: 'Completed' },
        { value: 'Cancelled', text: 'Cancelled' },
      ],
    };
  },
  methods: {
    submitForm() {
      this.$emit('createInterview', { ...this.interview }); // Emit interview data to the parent component
      this.closeModal(); // Close the modal after submission
    },
    closeModal() {
      this.$emit('update:showCreateModal', false); // Emit updated showCreateModal state to hide the modal
    },
  },
};
</script>

<style scoped>
/* Add custom styling for the modal here if necessary */
</style>
